import {Slider} from "../../../../../../../common/design2/slider/slider";

export const SliderLH = (
    {
        xdQaNamePrefix, low, high, state, background, format,
    }
) => {
    const lowIndexToV1  = (index) => index / low .length;
    const highIndexToV1 = (index) => (index + 1) / high.length;

    const lowToV1  = (v) => lowIndexToV1 (low .indexOf(v));

    const highToV1 = (v) => highIndexToV1(high.indexOf(v));

    const v1ToIndex = (v1) => Math.round(v1 * low .length);
    const v1ToLowIndex  = (v1) => Math.min(v1ToIndex(v1), low.length - 1);
    const v1ToHighIndex = (v1) => Math.max(0, v1ToIndex(v1) - 1);

    const v1ToLow  = (v1) => low [v1ToLowIndex (v1)];
    const v1ToHigh = (v1) => high[v1ToHighIndex(v1)];

    const toGetLabel = (getLabel, from1) => getLabel && ((v) => getLabel(from1(v)));

    return Slider({
        state: {
            value: {
                from: lowToV1 (state.value.from),
                to  : highToV1(state.value.to ),
            },
            onChange: (v1) => state.onChange({
                from: v1ToLow (v1.from),
                to  : v1ToHigh(v1.to),
            }),
        },
        background,
        getLabelFrom: toGetLabel(format.getLabelLow  ?? format.getLabel, v1ToLow ),
        getLabelTo  : toGetLabel(format.getLabelHigh ?? format.getLabel, v1ToHigh),

        translateDragging: (dragging) => dragging.oriValue <= dragging.otherValue ? (() => {
            const lowIndex = v1ToLowIndex(dragging.value);

            return {
                from: lowIndexToV1(lowIndex),
                to  : lowIndex < v1ToIndex(dragging.otherValue) ? (
                    dragging.otherValue
                ) : (
                    highIndexToV1 (lowIndex)
                ),
            };
        })() : (() => {
            const highIndex = v1ToHighIndex(dragging.value);

            return {
                to  : highIndexToV1(highIndex),
                from: highIndex > v1ToIndex(dragging.otherValue) ? (
                    dragging.otherValue
                ) : (
                    lowIndexToV1 (highIndex)
                ),
            };
        })(),
        xdQaNamePrefix,
    });
};